import script from "./small_methods.vue?vue&type=script&lang=js"
export * from "./small_methods.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__